<template>
  <v-container>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else-if="!_.isEmpty(this.annualreview)">
      <annual-review-app-bar></annual-review-app-bar>
      <annual-review-navigation-drawer></annual-review-navigation-drawer>
      <v-container>
        <annual-review-top-card
          :tab="tab"
          v-if="annualreview.completeDate == null"
        ></annual-review-top-card>
        <core-board
          v-if="tab == 0"
          :annualreview="annualreview"
          :user="annualreview.user"
          hide-header
        ></core-board>
        <annual-review-questions
          ref="questions"
          v-if="tab == 1"
          v-on:save="questionsSaved"
        ></annual-review-questions>
        <annual-review-signoff
          v-if="tab == 2"
          v-on:tab="changeTab"
        ></annual-review-signoff>
      </v-container>
      <annual-review-footer v-on:save="submitQuestions"></annual-review-footer>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AnnualReviewAppBar from "@/components/layout/AnnualReviewAppBar";
import AnnualReviewNavigationDrawer from "@/components/layout/AnnualReviewNavigationDrawer";
import AnnualReviewFooter from "@/components/layout/AnnualReviewFooter";
import CoreBoard from "@/components/corecard/CoreBoard";
import AnnualReviewQuestions from "@/components/annualreviews/AnnualReviewQuestions";
import AnnualReviewTopCard from "@/components/annualreviews/AnnualReviewTopCard";
import AnnualReviewSignoff from "@/components/annualreviews/AnnualReviewSignoff";
export default {
  name: "AnnualReviewDetails",
  components: {
    AnnualReviewAppBar,
    AnnualReviewNavigationDrawer,
    CoreBoard,
    AnnualReviewQuestions,
    AnnualReviewFooter,
    AnnualReviewTopCard,
    AnnualReviewSignoff
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      tab: "annualreview/tab",
      annualreview: "annualreview/annualreview",
      annualreview_tab: "annualreview/tab"
    })
  },
  created() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch("annualreview/getAnnualReview", {
        id: this.$route.params.id,
        userId: this.$route.params.userId
      }),
      this.$store.dispatch(
        "annualreview/getAnnualReviewHistory",
        this.$route.params.userId
      ),
      this.$store.dispatch("annualreview/setDrawer", false)
    ])
      .then(() => {
        this.goToTab();
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading annual review."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    goToTab() {
      switch (this.$route.params.tab) {
        case "coreboard":
          this.changeTab(0);
          break;
        case "signoff":
          this.changeTab(2);
          break;
      }
    },
    questionsSaved() {
      this.changeTab(2);
    },
    submitQuestions() {
      this.$refs.questions.save();
    },
    changeTab(tab) {
      this.$store.dispatch("annualreview/setTab", tab);
    }
  }
};
</script>
